(function () {
  'use strict';

  if (window.SIMPLYMDRN_CART_DRAWER_V2) return;
  window.SIMPLYMDRN_CART_DRAWER_V2 = true;

  var productCache = {};
  var activeCartKey = '';
  var activeUpsellCategory = 'cases';
  var upsellProducts = [];
  var upsellCart = null;
  var cartMutationPending = false;
  var pendingCartRenderKey = null;
  var preservedCartScroll = null;
  var cartCountRevision = 0;
  var giftReconcilePending = false;
  var giftProductIds = {
    keychain: [8896218235070],
    protector: [8782502723774, 8782502756542],
    wallet: [8991917670590]
  };
  function rewardThresholds() {
    var root = document.querySelector('cart-drawer .smd-rewards');
    if (!root) return null;
    var thresholds = {
      keychain: Number(root.getAttribute('data-smd-threshold-keychain')),
      protector: Number(root.getAttribute('data-smd-threshold-protector')),
      wallet: Number(root.getAttribute('data-smd-threshold-wallet'))
    };
    return thresholds.keychain > 0 && thresholds.protector > thresholds.keychain && thresholds.wallet > thresholds.protector ? thresholds : null;
  }

  function rewardCurrencyMatches(cart) {
    var drawer = document.querySelector('cart-drawer');
    return drawer && cart.currency === drawer.getAttribute('data-smd-currency');
  }
  function cartScrollArea() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]');
  }
  function restoreCartScroll() {
    var area = cartScrollArea();
    if (area && preservedCartScroll !== null) {
      area.scrollTop = Math.min(preservedCartScroll, Math.max(0, area.scrollHeight - area.clientHeight));
      preservedCartScroll = null;
    }
  }
  function syncCartCount(cart) {
    if (!cart || !Number.isFinite(Number(cart.item_count))) return;
    var count = Number(cart.item_count);
    document.querySelectorAll('cart-count').forEach(function (bubble) {
      var screenReaderCount = bubble.querySelector('.sr-only');
      var visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (screenReaderCount && visibleCount) {
        screenReaderCount.textContent = count + (count === 1 ? ' item' : ' items');
        visibleCount.textContent = String(count);
      } else {
        bubble.textContent = String(count);
      }
    });
  }
  function routesRoot() {
    var declared = document.querySelector('[data-smd-wallet-upsell]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      || (declared && declared.getAttribute('data-smd-locale-root')) || '/';
    return /\/$/.test(root) ? root : root + '/';
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\b(card|wallet|case|series|slim|carbon|iphone|samsung|galaxy|s1|s2)\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function tokens(value) {
    return normalize(value).split(' ').filter(function (token) { return token.length > 2; });
  }

  function category(product) {
    if (product._smdCategory && product._smdCategory !== 'featured') return product._smdCategory;
    var text = (product.title || '') + ' ' + (product.product_type || '') + ' ' + (product.handle || '');
    if (/screen protector/i.test(text)) return 'screen';
    if (/\bcard\b|wallet/i.test(text)) return 'wallet';
    if (/keychain|key chain/i.test(text)) return 'keychain';
    return 'case';
  }

  function categoryLabel(product) {
    var value = category(product);
    if (value === 'wallet') return 'CARD WALLET';
    if (value === 'keychain') return 'KEYCHAIN';
    if (value === 'screen') return 'SCREEN PROTECTOR';
    return 'PHONE CASE';
  }

  function displayTitle(title, handle) {
    var value = String(title || '').trim().replace(/\(S([12])\)/g, '[S$1]');
    if (/-slim-/.test(handle || '')) return value.split('|')[0].trim() + ' | SLIM [' + (/SLIM \[S1\]/.test(value) ? 'S1' : 'S2') + ']';
    if (/-carbon-/.test(handle || '')) return value.split('|')[0].trim() + ' | CARBON [S1]';
    if (/\|\s*CARD\s*\[S1\]\s*$/i.test(value)) {
      return value.replace(/\s*\|\s*CARD\s*\[S1\]\s*$/i, '').trim() + ' CARD WALLET';
    }
    return value;
  }

  function availableVariants(product) {
    return (product.variants || []).filter(function (variant) { return variant.available !== false; });
  }

  function modelFromCart(items) {
    for (var i = 0; i < items.length; i += 1) {
      if (/screen protector/i.test((items[i].product_title || '') + ' ' + (items[i].product_type || ''))) continue;
      var options = items[i].options_with_values || [];
      for (var j = 0; j < options.length; j += 1) {
        if (/device|model|phone|compatible/i.test(options[j].name || '')) return options[j].value || '';
      }
      if (items[i].variant_title && items[i].variant_title !== 'Default Title' && /iphone|galaxy|samsung|pixel/i.test(items[i].variant_title)) {
        return items[i].variant_title;
      }
    }
    return '';
  }

  function matchingVariant(variants, model) {
    if (!variants.length || !model) return null;
    var target = normalize(model);
    return variants.find(function (variant) {
      return [variant.title, variant.option1, variant.option2, variant.option3].some(function (value) {
        var candidate = normalize(value);
        return candidate === target || (/\bair\b/.test(target) && candidate === 'air');
      });
    }) || null;
  }

  function rewardKind(item) {
    var id = Number(item.product_id);
    return Object.keys(giftProductIds).find(function (kind) { return giftProductIds[kind].indexOf(id) !== -1; }) || '';
  }

  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (rewardKind(item) ? 0 : Number(item.original_line_price || 0));
    }, 0);
  }

  function setupGiftSelector(cart) {
    var select = document.querySelector('cart-drawer [data-smd-gift-size]');
    if (!select) return;
    var model = normalize(modelFromCart(cart.items || []));
    if (model && !select.value) {
      var match = Array.prototype.find.call(select.options, function (option) {
        return option.value && normalize(option.getAttribute('data-model')) === model;
      });
      if (match) select.value = match.value;
    }
    var button = select.closest('.smd-rewards__claim') && select.closest('.smd-rewards__claim').querySelector('[data-smd-gift-claim="protector"]');
    if (button) button.disabled = !select.value;
    updateGiftPreview(select);
  }

  function updateGiftPreview(select) {
    var claim = select.closest('.smd-rewards__claim');
    var option = select.options[select.selectedIndex];
    if (!claim || !option || !option.value) return;
    var image = claim.querySelector('[data-smd-gift-preview]');
    var price = claim.querySelector('[data-smd-gift-original-price]');
    if (image && option.dataset.image) image.src = option.dataset.image;
    if (price && option.dataset.price) price.innerHTML = option.dataset.price;
  }

  function cents(value) {
    var raw = String(value == null ? '' : value);
    var number = Number(raw);
    if (!Number.isFinite(number)) return 0;
    return raw.indexOf('.') >= 0 ? Math.round(number * 100) : Math.round(number);
  }

  function money(value) {
    var amount = cents(value) / 100;
    var currency = (upsellCart && upsellCart.currency)
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'CAD';
    try {
      var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
      return formatted + ' ' + currency;
    } catch (error) {
      return '$' + amount.toFixed(2) + ' ' + currency;
    }
  }

  function imageURL(product) {
    var image = product.images && product.images.length ? product.images[0] : null;
    if (!image && product.featured_image) image = product.featured_image;
    var source = image && (image.src || image);
    return source ? String(source).split('?')[0] + '?width=240' : '';
  }

  function productURL(product) {
    return routesRoot() + 'products/' + encodeURIComponent(product.handle);
  }

  function selectorHTML(product, variant, selectClass, label) {
    var variants = availableVariants(product);
    if (variants.length <= 1) {
      return '<span class="smd-upsell-card__select smd-upsell-card__static">ONE SIZE</span>';
    }
    return '<select class="' + selectClass + '" data-smd-variant-select aria-label="' + escapeHTML(label) + '">'
      + variants.map(function (item) {
        return '<option value="' + escapeHTML(item.id) + '" data-price="' + escapeHTML(item.price) + '" data-compare="' + escapeHTML(item.compare_at_price || '') + '" data-image="' + escapeHTML((item.featured_image && (item.featured_image.src || item.featured_image)) || imageURL(product)) + '"'
          + (variant && String(item.id) === String(variant.id) ? ' selected' : '') + '>'
          + escapeHTML(item.title) + '</option>';
      }).join('') + '</select>';
  }

  function scoreProduct(product, cartItems) {
    var productTokens = tokens(product.title + ' ' + product.handle);
    var score = 0;
    cartItems.forEach(function (item) {
      tokens((item.product_title || '') + ' ' + (item.handle || '')).forEach(function (token) {
        if (productTokens.indexOf(token) >= 0) score += token === 'jokster' ? 3 : 8;
      });
    });
    return score;
  }

  function priceMarkup(variant) {
    var price = cents(variant.price);
    var compare = cents(variant.compare_at_price);
    if (compare > price && price > 0) {
      var percent = Math.round((compare - price) * 100 / compare);
      return '<s>' + escapeHTML(money(compare)) + '</s> ' + escapeHTML(money(price)) + ' <strong>' + percent + '% OFF</strong>';
    }
    return escapeHTML(money(price));
  }

  function cardHTML(product, model) {
    var variants = availableVariants(product);
    if (!variants.length) return '';
    var variant = variants.length === 1 ? variants[0] : (matchingVariant(variants, model) || variants[0]);
    var image = variant.featured_image && (variant.featured_image.src || variant.featured_image);
    image = image || imageURL(product);
    var link = productURL(product) + '?variant=' + encodeURIComponent(variant.id);
    var priceHTML = priceMarkup(variant);
    return '<article class="smd-upsell-card" role="listitem" data-product-id="' + escapeHTML(product.id) + '" data-smd-category="' + escapeHTML(category(product)) + '" data-smd-product-url="' + escapeHTML(productURL(product)) + '">'
      + '<a class="smd-upsell-card__image" href="' + escapeHTML(link) + '" tabindex="-1">'
      + (image ? '<img src="' + escapeHTML(image) + '" loading="lazy" alt="' + escapeHTML(product.title + ' — ' + variant.title) + '">' : '') + '</a>'
      + '<div class="smd-upsell-card__body">'
      + '<a class="smd-upsell-card__title" href="' + escapeHTML(link) + '">' + escapeHTML(displayTitle(product.title, product.handle)) + '</a>'
      + '<span class="smd-upsell-card__price" data-smd-price data-smd-regular-price="' + escapeHTML(variant.price) + '">' + priceHTML + '</span>'
      + '<div class="smd-upsell-card__controls">'
      + selectorHTML(product, variant, 'smd-upsell-card__select', 'Choose size or style')
      + '<button type="button" class="smd-upsell-card__add" data-smd-add="' + escapeHTML(variant.id) + '" aria-label="Add ' + escapeHTML(displayTitle(product.title, product.handle)) + ' to cart">ADD TO CART</button>'
      + '</div></div></article>';
  }

  function updateSlider(root) {
    var list = root && root.querySelector('[data-smd-wallet-list]');
    if (!list) return;
    var cards = list.querySelectorAll('.smd-upsell-card');
    if (!cards.length) return;
    var listBox = list.getBoundingClientRect();
    Array.prototype.forEach.call(cards, function (card) {
      var box = card.getBoundingClientRect();
      var visibleWidth = Math.max(0, Math.min(box.right, listBox.right) - Math.max(box.left, listBox.left));
      var visible = visibleWidth >= Math.min(box.width * 0.65, listBox.width * 0.65);
      card.inert = !visible;
      card.setAttribute('aria-hidden', String(!visible));
    });
    var firstOffset = cards[0].offsetLeft;
    var activeIndex = 0;
    var nearestDistance = Infinity;
    Array.prototype.forEach.call(cards, function (card, index) {
      var distance = Math.abs(card.offsetLeft - firstOffset - list.scrollLeft);
      if (distance < nearestDistance) { nearestDistance = distance; activeIndex = index; }
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-smd-upsell-dot]'), function (dot, index) {
      dot.setAttribute('aria-current', String(index === activeIndex));
    });
  }

  function renderUpsells(products, cart) {
    var scrollArea = cartScrollArea();
    var scrollTop = scrollArea ? scrollArea.scrollTop : 0;
    upsellProducts = products;
    upsellCart = cart;
    var root = document.querySelector('[data-smd-wallet-upsell]');
    if (!root) return;
    var list = root.querySelector('[data-smd-wallet-list]');
    if (!list) return;

    var items = cart.items || [];
    var model = modelFromCart(items);
    var cartProductIds = items.map(function (item) { return Number(item.product_id); });
    var unlockedGiftCategories = [];
    var thresholds = rewardThresholds();
    if (thresholds && rewardCurrencyMatches(cart)) {
      var merchandise = qualifyingSubtotal(cart);
      if (merchandise >= thresholds.keychain) unlockedGiftCategories.push('keychain');
      if (merchandise >= thresholds.protector) unlockedGiftCategories.push('screen');
      if (merchandise >= thresholds.wallet) unlockedGiftCategories.push('wallet');
    }
    var order = ['case', 'screen', 'keychain'];
    var candidates = products
      .filter(function (product) {
        var productCategory = category(product);
        var wrongPlatform = model && ((/iphone/i.test(model) && /samsung|galaxy/i.test(product.handle)) || (/samsung|galaxy/i.test(model) && /iphone/i.test(product.handle)));
        var screenIsCompatible = productCategory !== 'screen' || (model && matchingVariant(availableVariants(product), model));
        return cartProductIds.indexOf(Number(product.id)) < 0 && unlockedGiftCategories.indexOf(productCategory) < 0 && availableVariants(product).length && !wrongPlatform && screenIsCompatible;
      })
      .map(function (product, index) {
        var productCategory = category(product);
        var variantMatch = matchingVariant(availableVariants(product), model) ? 60 : 0;
        return { product: product, index: index, category: productCategory, score: variantMatch + scoreProduct(product, items) };
      });

    var visibleCandidates = candidates.filter(function (entry) { return order.indexOf(entry.category) >= 0; });
    var selected = [];
    var groups = {};
    order.forEach(function (targetCategory) {
      groups[targetCategory] = visibleCandidates.filter(function (entry) { return entry.category === targetCategory; })
        .sort(function (a, b) { return b.score - a.score || a.index - b.index; });
    });
    var longestGroup = Math.max.apply(Math, order.map(function (targetCategory) { return groups[targetCategory].length; }));
    for (var round = 0; round < longestGroup; round += 1) {
      order.forEach(function (targetCategory) {
        if (groups[targetCategory][round]) selected.push(groups[targetCategory][round]);
      });
    }

    if (activeUpsellCategory === 'accessories') {
      selected.sort(function (a, b) { return order.indexOf(a.category) - order.indexOf(b.category); });
    }
    var seen = {};
    var maximum = Math.max(3, Math.min(8, Number(root.getAttribute('data-smd-upsell-limit')) || 6));
    var cards = selected.filter(function (entry) {
      if (seen[entry.product.id]) return false;
      seen[entry.product.id] = true;
      return true;
    }).slice(0, maximum).map(function (entry) { return cardHTML(entry.product, model); }).filter(Boolean);

    Array.prototype.forEach.call(root.querySelectorAll('[data-smd-upsell-tab]'), function (tab) {
      var selectedTab = tab.getAttribute('data-smd-upsell-tab') === activeUpsellCategory;
      tab.setAttribute('aria-selected', String(selectedTab));
      tab.tabIndex = selectedTab ? 0 : -1;
    });

    list.innerHTML = cards.length ? cards.join('') : '<p class="smd-cart-upsell__empty">No more ' + (activeUpsellCategory === 'cases' ? 'matching cases' : 'matching accessories') + ' to add right now.</p>';
    root.setAttribute('data-smd-rendered-cart-key', (cart.items || []).map(function (item) { return item.key + ':' + item.quantity; }).join('|'));
    list.scrollLeft = 0;
    if (scrollArea) scrollArea.scrollTop = Math.min(scrollTop, Math.max(0, scrollArea.scrollHeight - scrollArea.clientHeight));
    var dots = root.querySelector('[data-smd-upsell-dots]');
    if (dots) {
      dots.hidden = cards.length < 2;
      dots.innerHTML = cards.map(function (card, index) {
        return '<button type="button" class="smd-cart-upsell__dot" data-smd-upsell-dot="' + index + '" aria-label="Show product ' + (index + 1) + ' of ' + cards.length + '" aria-current="' + (index === 0) + '"></button>';
      }).join('');
    }
    root.hidden = !cards.length;
    window.requestAnimationFrame(function () { updateSlider(root); });
  }

  function fetchProduct(handle) {
    return fetch(routesRoot() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) { if (!response.ok) throw new Error('product'); return response.json(); });
  }

  function fetchCollection(handle) {
    if (!handle) return Promise.resolve([]);
    return fetch(routesRoot() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=24')
      .then(function (response) { if (!response.ok) throw new Error('collection'); return response.json(); })
      .then(function (payload) { return loadHandles((payload.products || []).map(function (product) { return product.handle; }), 'featured'); })
      .catch(function () { return []; });
  }

  function parseHandles(root, attribute) {
    return String(root.getAttribute(attribute) || '').split(',').map(function (handle) { return handle.trim(); }).filter(Boolean);
  }

  function loadHandles(handles, sourceCategory) {
    return Promise.all(handles.map(function (handle) {
      return fetchProduct(handle).then(function (product) { product._smdCategory = sourceCategory; return product; }).catch(function () { return null; });
    })).then(function (products) { return products.filter(Boolean); });
  }

  function uniqueProducts(products) {
    var seen = {};
    return products.filter(function (product) {
      var key = String(product.id || product.handle);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function loadConfiguredProducts(root) {
    var featured = parseHandles(root, 'data-smd-featured-handles');
    var keychains = parseHandles(root, 'data-smd-keychain-handles');
    var screens = parseHandles(root, 'data-smd-screen-handles');
    if (!keychains.length) keychains = ['jok3ster-embroidered-keychain-1pk'];
    if (!screens.length) screens = ['screen-protector-iphone', 'screen-protector-samsung-galaxy'];
    var walletCollection = root.getAttribute('data-smd-wallet-collection') || 'card-series-1';
    var caseCollection = root.getAttribute('data-smd-case-collection') || 'best-sellers';
    var additionalCases = root.getAttribute('data-smd-additional-case-collection') || '';
    var key = [routesRoot(), featured.join(','), keychains.join(','), screens.join(','), walletCollection, caseCollection, additionalCases].join('|');
    if (!productCache[key]) {
      productCache[key] = Promise.all([
        loadHandles(featured, 'featured'),
        fetchCollection(additionalCases),
        fetchCollection(caseCollection).then(function (products) {
          return products.filter(function (product) { return category(product) === 'case'; }).map(function (product) {
            product._smdCategory = 'case';
            return product;
          });
        }),
        loadHandles(keychains, 'keychain'),
        loadHandles(screens, 'screen')
      ]).then(function (groups) {
        return { upsells: uniqueProducts(groups[0].concat(groups[1], groups[2], groups[3])), screens: uniqueProducts(groups[4]) };
      });
    }
    return productCache[key];
  }

  function updateQuantityState(wrapper) {
    var input = wrapper && wrapper.querySelector('input[data-line-key]');
    if (!input) return;
    var value = Number(input.value) || 1;
    var minimum = Number(input.min) || 1;
    var decrease = wrapper.querySelector('[data-smd-quantity-step="-1"]');
    if (decrease) decrease.disabled = value <= minimum;
  }

  function enhanceQuantityControls() {
    document.querySelectorAll('cart-drawer line-item-quantity input[data-line-key]').forEach(function (input) {
      if (input.closest('.smd-quantity')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'smd-quantity';
      var decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.className = 'smd-quantity__button';
      decrease.setAttribute('data-smd-quantity-step', '-1');
      decrease.setAttribute('aria-label', 'Decrease quantity');
      decrease.textContent = '\u2212';
      var increase = document.createElement('button');
      increase.type = 'button';
      increase.className = 'smd-quantity__button';
      increase.setAttribute('data-smd-quantity-step', '1');
      increase.setAttribute('aria-label', 'Increase quantity');
      increase.textContent = '+';
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(decrease);
      wrapper.appendChild(input);
      wrapper.appendChild(increase);
      updateQuantityState(wrapper);
    });
  }

  function stepQuantity(button) {
    var wrapper = button.closest('.smd-quantity');
    var input = wrapper && wrapper.querySelector('input[data-line-key]');
    if (!input || button.disabled || cartMutationPending) return;
    var direction = Number(button.getAttribute('data-smd-quantity-step')) || 0;
    var minimum = Number(input.min) || 1;
    input.value = String(Math.max(minimum, (Number(input.value) || minimum) + direction));
    updateQuantityState(wrapper);
    changeLineByKey(input.getAttribute('data-line-key'), Number(input.value));
  }

  function beginCartMutation(label) {
    if (cartMutationPending) return null;
    cartMutationPending = true;
    pendingCartRenderKey = null;
    var drawer = document.querySelector('cart-drawer');
    var renderRootBefore = drawer && drawer.querySelector('[data-smd-wallet-upsell]');
    var controls = drawer ? Array.prototype.map.call(drawer.querySelectorAll('[data-smd-quantity-step], input[data-line-key], .smd-cart-footer button, [data-smd-gift-claim], [data-smd-gift-size]'), function (control) {
      var previous = control.disabled;
      control.disabled = true;
      return { control: control, disabled: previous };
    }) : [];
    if (drawer) {
      drawer.setAttribute('aria-busy', 'true');
      var loading = drawer.querySelector('.smd-cart-loading');
      if (loading) loading.textContent = label || 'Updating your cart…';
    }
    var releaseControls = function () {
      cartMutationPending = false;
      pendingCartRenderKey = null;
      controls.forEach(function (entry) { if (entry.control.isConnected) entry.control.disabled = entry.disabled; });
      var currentDrawer = document.querySelector('cart-drawer');
      if (currentDrawer) currentDrawer.removeAttribute('aria-busy');
      enhanceQuantityControls();
    };
    return function () {
      if (pendingCartRenderKey === null) { releaseControls(); return; }
      var deadline = Date.now() + 10000;
      return new Promise(function (resolve) {
        function waitForRender() {
          var root = document.querySelector('[data-smd-wallet-upsell]');
          var ready = pendingCartRenderKey === '' ? !root : root && root !== renderRootBefore && root.getAttribute('data-smd-rendered-cart-key') === pendingCartRenderKey;
          if (ready || Date.now() >= deadline) { releaseControls(); resolve(); }
          else window.setTimeout(waitForRender, 40);
        }
        window.setTimeout(waitForRender, 80);
      });
    };
  }

  function changeLine(identifier, quantity, useKey) {
    if (!identifier || quantity < 0) return;
    var finishMutation = beginCartMutation();
    if (!finishMutation) return;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    fetch(routesRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(Object.assign(useKey ? { id: identifier } : { line: identifier }, { quantity: quantity, sections: sections, sections_url: window.location.pathname }))
    })
      .then(function (response) { return response.json().then(function (payload) { if (!response.ok) throw new Error(payload.description || 'Unable to update cart'); return payload; }); })
      .then(function (cart) {
        activeCartKey = '';
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
      })
      .catch(function (error) {
        var drawer = document.querySelector('cart-drawer');
        var status = drawer && drawer.querySelector('[data-smd-wallet-status]');
        if (status) status.textContent = error.message || 'Could not update cart. Try again.';
      })
      .finally(finishMutation);
  }

  function changeLineByIndex(lineIndex, quantity) { changeLine(lineIndex, quantity, false); }
  function changeLineByKey(lineKey, quantity) { changeLine(lineKey, quantity, true); }

  function statusFor(button) {
    var upsell = button.closest('[data-smd-wallet-upsell]');
    return upsell && upsell.querySelector('[data-smd-wallet-status]');
  }

  function addItem(button) {
    var variantId = Number(button.getAttribute('data-smd-add'));
    var status = statusFor(button);
    if (!variantId || button.disabled) return;
    var finishMutation = beginCartMutation('Adding to your cart…');
    if (!finishMutation) return;
    button.disabled = true;
    button.textContent = 'ADDING';
    if (status) status.textContent = '';

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var lineItem = { id: variantId, quantity: 1 };
    fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [lineItem], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (response) { return response.json().then(function (payload) { if (!response.ok) throw new Error(payload.description || 'Unable to add item'); return payload; }); })
      .then(function (addResponse) {
        return fetch(routesRoot() + 'cart.js').then(function (response) { if (!response.ok) throw new Error('Unable to refresh cart'); return response.json(); })
          .then(function (cart) { cart.sections = addResponse.sections || {}; return cart; });
      })
      .then(function (cart) {
        button.textContent = 'ADDED';
        button.setAttribute('aria-checked', 'true');
        if (status) status.textContent = 'Added to cart.';
        activeCartKey = '';
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = 'RETRY';
        if (status) status.textContent = error.message || 'Could not add this item. Try again.';
      })
      .finally(finishMutation);
  }

  function claimGift(button) {
    var kind = button.getAttribute('data-smd-gift-claim');
    var thresholds = rewardThresholds();
    var select = kind === 'protector' && button.closest('.smd-rewards__claim').querySelector('[data-smd-gift-size]');
    var variantId = Number(select ? select.value : button.getAttribute('data-smd-gift-variant'));
    var status = button.closest('.smd-rewards__claims').querySelector('[data-smd-gift-status]');
    if (!thresholds || !thresholds[kind] || !variantId || button.disabled || cartMutationPending) return;
    var finishMutation = beginCartMutation('Adding your gift…');
    if (!finishMutation) return;
    status.textContent = '';
    button.textContent = 'ADDING';
    fetch(routesRoot() + 'cart.js')
      .then(function (response) { if (!response.ok) throw new Error('Unable to check cart'); return response.json(); })
      .then(function (cart) {
        if (!rewardCurrencyMatches(cart) || qualifyingSubtotal(cart) < thresholds[kind]) throw new Error('This gift is no longer unlocked.');
        if ((cart.items || []).some(function (item) { return rewardKind(item) === kind; })) throw new Error('This gift is already in your cart.');
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        return fetch(routesRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _smd_reward: kind } }], sections: sections, sections_url: window.location.pathname })
        });
      })
      .then(function (response) { return response.json().then(function (payload) { if (!response.ok) throw new Error(payload.description || 'Unable to add gift'); return payload; }); })
      .then(function (addResponse) {
        return fetch(routesRoot() + 'cart.js').then(function (response) { if (!response.ok) throw new Error('Unable to refresh cart'); return response.json(); })
          .then(function (cart) { cart.sections = addResponse.sections || {}; return cart; });
      })
      .then(function (cart) {
        status.textContent = 'Gift added to cart.';
        activeCartKey = '';
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      })
      .catch(function (error) {
        button.textContent = 'CLAIM';
        status.textContent = error.message || 'Could not add gift. Try again.';
      })
      .finally(finishMutation);
  }

  function reconcileGiftCart() {
    if (!document.querySelector('cart-drawer .smd-rewards')) return;
    if (cartMutationPending || giftReconcilePending) return;
    giftReconcilePending = true;
    fetch(routesRoot() + 'cart.js')
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(function (cart) {
        var subtotal = qualifyingSubtotal(cart);
        var thresholds = rewardThresholds();
        var index = (cart.items || []).findIndex(function (item) {
          var kind = item.properties && item.properties._smd_reward;
          return kind && giftProductIds[kind] && (!thresholds || !rewardCurrencyMatches(cart) || subtotal < thresholds[kind] || item.quantity > 1);
        });
        if (index < 0) return;
        var item = cart.items[index];
        var kind = item.properties._smd_reward;
        changeLineByKey(item.key, thresholds && rewardCurrencyMatches(cart) && subtotal >= thresholds[kind] ? 1 : 0);
      })
      .catch(function () { /* Cart updates still work if this background check fails. */ })
      .finally(function () { giftReconcilePending = false; });
  }

  function loadUpsell() {
    var root = document.querySelector('[data-smd-wallet-upsell]');
    if (!root) return;
    fetch(routesRoot() + 'cart.js')
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        setupGiftSelector(cart);
        var key = cart.items.map(function (item) { return item.key + ':' + item.quantity; }).join('|');
        if (activeCartKey === key && root.querySelector('.smd-upsell-card')) return;
        activeCartKey = key;
        return loadConfiguredProducts(root).then(function (products) {
          renderUpsells(uniqueProducts(products.upsells.concat(products.screens)), cart);
        });
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-smd-upsell-tab]');
    if (tab) {
      activeUpsellCategory = tab.getAttribute('data-smd-upsell-tab') === 'accessories' ? 'accessories' : 'cases';
      if (upsellCart) renderUpsells(upsellProducts, upsellCart);
      return;
    }
    var removeLink = event.target.closest && event.target.closest('cart-drawer [data-smd-remove-line]');
    if (!removeLink) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    changeLineByIndex(Number(removeLink.getAttribute('data-smd-remove-line')) || 0, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-smd-quantity-step]');
    if (quantityButton) { stepQuantity(quantityButton); return; }
    var giftButton = event.target.closest('[data-smd-gift-claim]');
    if (giftButton) { claimGift(giftButton); return; }
    var addButton = event.target.closest('[data-smd-add]');
    if (addButton) { addItem(addButton); return; }
    var dot = event.target.closest('[data-smd-upsell-dot]');
    if (!dot) return;
    var root = dot.closest('[data-smd-wallet-upsell]');
    var list = root && root.querySelector('[data-smd-wallet-list]');
    if (!list) return;
    var cards = list.querySelectorAll('.smd-upsell-card');
    var index = Number(dot.getAttribute('data-smd-upsell-dot'));
    if (!cards[index]) return;
    list.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    window.setTimeout(function () { updateSlider(root); }, 320);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-smd-gift-size]')) {
      var giftButton = event.target.closest('.smd-rewards__claim').querySelector('[data-smd-gift-claim]');
      if (giftButton) giftButton.disabled = !event.target.value;
      updateGiftPreview(event.target);
      return;
    }
    var select = event.target.closest('[data-smd-variant-select]');
    if (!select) return;
    var container = select.closest('.smd-upsell-card');
    var option = select.options[select.selectedIndex];
    var button = container && container.querySelector('[data-smd-add]');
    var price = container && container.querySelector('[data-smd-price]');
    if (button) {
      button.setAttribute('data-smd-add', select.value);
      button.disabled = !select.value;
      button.textContent = 'ADD TO CART';
      button.setAttribute('aria-checked', 'false');
    }
    if (container && option) {
      var image = container.querySelector('.smd-upsell-card__image img');
      if (image && option.dataset.image) { image.src = option.dataset.image; image.alt = container.querySelector('.smd-upsell-card__title').textContent + ' — ' + option.textContent; }
      container.querySelectorAll('a').forEach(function (a) { a.href = container.dataset.smdProductUrl + '?variant=' + encodeURIComponent(select.value); });
    }
    if (price && option && option.getAttribute('data-price')) {
      var selectedPrice = option.getAttribute('data-price');
      price.setAttribute('data-smd-regular-price', selectedPrice);
      price.innerHTML = priceMarkup({ price: selectedPrice, compare_at_price: option.getAttribute('data-compare') });
    }
  });

  document.addEventListener('scroll', function (event) {
    var list = event.target.closest && event.target.closest('[data-smd-wallet-list]');
    if (list) updateSlider(list.closest('[data-smd-wallet-upsell]'));
  }, true);

  window.addEventListener('resize', function () { updateSlider(document.querySelector('[data-smd-wallet-upsell]')); });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-smd-upsell-tab]');
    if (!tab || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) < 0) return;
    event.preventDefault();
    var targetCategory = event.key === 'Home' ? 'cases' : event.key === 'End' ? 'accessories' : (tab.getAttribute('data-smd-upsell-tab') === 'cases' ? 'accessories' : 'cases');
    var targetTab = tab.closest('[data-smd-wallet-upsell]').querySelector('[data-smd-upsell-tab="' + targetCategory + '"]');
    if (targetTab) { targetTab.focus(); targetTab.click(); }
  });

  document.addEventListener('dialog:after-show', function (event) {
    if (event.target && event.target.matches('cart-drawer')) { enhanceQuantityControls(); loadUpsell(); }
  });

  document.addEventListener('cart:change', function (event) {
    var area = cartScrollArea();
    preservedCartScroll = area ? area.scrollTop : null;
    if (cartMutationPending && event.detail && event.detail.cart) pendingCartRenderKey = (event.detail.cart.items || []).map(function (item) { return item.key + ':' + item.quantity; }).join('|');
  }, true);

  var nativeMutationFinish = null;
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('form[is="product-form"]') || !event.target.checkValidity()) return;
    if (cartMutationPending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    nativeMutationFinish = beginCartMutation('Adding to your cart…');
  }, true);
  document.addEventListener('cart:change', function (event) {
    if (nativeMutationFinish && event.detail && event.detail.baseEvent === 'variant:add') {
      var finish = nativeMutationFinish;
      nativeMutationFinish = null;
      finish();
    }
  });
  document.addEventListener('cart:error', function () {
    if (nativeMutationFinish) { nativeMutationFinish(); nativeMutationFinish = null; }
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      var revision = ++cartCountRevision;
      var changedCart = event.detail.cart;
      syncCartCount(changedCart);
      [180, 1200].forEach(function (delay) {
        window.setTimeout(function () { if (revision === cartCountRevision) syncCartCount(changedCart); }, delay);
      });
    }
    activeCartKey = '';
    window.setTimeout(loadUpsell, 160);
    window.setTimeout(reconcileGiftCart, 350);
    window.setTimeout(loadUpsell, 1100);
    window.setTimeout(enhanceQuantityControls, 1200);
  });

  var observer = new MutationObserver(function (mutations) {
    var replaced = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === 1 && ((node.matches && node.matches('[data-smd-wallet-upsell]')) || (node.querySelector && node.querySelector('[data-smd-wallet-upsell]')));
      });
    });
    if (!replaced) return;
    restoreCartScroll();
    activeCartKey = '';
    window.setTimeout(loadUpsell, 100);
    window.setTimeout(reconcileGiftCart, 300);
    window.setTimeout(enhanceQuantityControls, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceQuantityControls(); loadUpsell(); reconcileGiftCart(); });
  } else {
    enhanceQuantityControls();
    loadUpsell();
    reconcileGiftCart();
  }
}());
